'use client';

import type React from 'react';
import clsx from 'clsx';

import { CopyButton } from '@/components/CopyButton/CopyButton'; // твой новый UI-кнопка
import styles from './IdField.module.scss';

type Props = {
  id: string | number;
  className?: string;
  stopPropagation?: boolean;
  copiedMessage?: string;
  withCopy?: boolean;
};

export const IdField = ({
  id,
  className,
  stopPropagation = false,
  copiedMessage = 'ID скопійовано',
  withCopy = true,
}: Props) => {
  return (
    <span className={clsx(styles.wrap, className)}>
      <span className={styles.label}>ID:</span>
      <span className={styles.value}>{id}</span>

      {withCopy && (
        <CopyButton
          stopPropagation={stopPropagation}
          textToCopy={String(id)}
          copiedMessage={copiedMessage}
          className={styles.copyBtn}
        />
      )}
    </span>
  );
};
